export default {
  state: {
    horizontal: null
  },
  mutations: {
    setHorizontal (state, payload) {
      state.horizontal = payload.horizontal
      console.log(payload.horizontal)
    }
  },
  getters: {
    horizontalSize (state) {
      if (state.horizontal) {
        return state.horizontal.size()
      }
      return 0
    }
  },
  actions: {
    setHorizontal ({state, commit}, payload) {
      commit('setHorizontal', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/menu.js